var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("\n<ninja-grid no-data-text=\"No addresses yet...\" grid-title=\"Company Adresses\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.addresses\" create-method=\"addAddress\" update-method=\"\" delete-method=\"deleteAddress\" add-toggle=\"vm.sideTab.addresses\" fields=\"{addressType: {input: 'text', header: 'Type', order: 10, width: 20, type: 'string'}, \n                 primary: {input: 'textarea', header: 'Primary', order: 20, width: 10, type: 'string'}, \n                 address1: {input: 'text', header: 'Address 1', order: 30, width: 10, type: 'string'},\n                 city: {input: 'text', header: 'City', order: 40, width: 10, type: 'string'},\n                 state: {input: 'text', header: 'State', order: 50, width: 10, type: 'string'},\n                 zip: {input: 'text', header: 'Zip', order: 60, width: 10, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/settings/tabs/addresses.jade
// module id = 172
// module chunks = 0